import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import instaImg from '../img/images/instaa.png';
import { supabase } from '../lib/supabaseClient.ts';



function Footer() {
  const [footer, setFooter] = useState(null);
  const [socialLinks, setSocialLinks] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [services, setServices] = useState([]);
  const [instaImages, setInstagram] = useState([]);
  const [shapes, setShapes] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const [{ data: policies }, { data: services }, { data: instagram }, { data: shapes }, { data: footer }, { data: social }] = await Promise.all([
        supabase.from('footer_policies').select('*'),
        supabase.from('footer_services').select('*'),
        supabase.from('footer_instagram').select('*'),
        supabase.from('footer_shapes').select('*'),
        supabase.from('footer').select('*').single(),
        supabase.from('footer_social_links').select('*'),
      ]);
      setServices(services);

      setPolicies(policies);
      setServices(services);
      setInstagram(instagram);
      setShapes(shapes);
      setFooter(footer);
      setSocialLinks(social);

    };
    fetchData();
  }, []);


  if (!footer) return null;

  return (
    <footer>
      <div className="footer-top-area footer-bg">
        <div className="container">
          <div className="row justify-content-between">

            {/* ── Logo / Contact / Social ── */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="footer-widget">
                <div className="f-logo">
                  <img src={footer.logo_url} alt="Footer Logo" />
                </div>
                <div className="footer-desktop">

                  <div className="footer-text">
                    <p>{footer.description}</p>
                  </div>
                </div>
                <div className="footer-mobile">

                  <div className="footer-text">
                    <p>Animalia Plus est votre boutique de confiance </p>
                    <p>pour  vos compagnons à quatre pattes !  </p>
                    <p> :nourriture,accessoires, jouets... </p>
                  </div>
                </div>
                <div className="footer-contact">
                  <div className="icon">
                    <i className="fas fa-headphones" />
                  </div>
                  <div className="content">
                    <h4 className="title">
                      <a href={`tel:${footer.phone}`}>{footer.phone}</a>
                    </h4>
                    <span>Appelez-nous</span>
                  </div>
                </div>

                <div className="footer-social">
                  <ul>
                    {socialLinks.map((link) => (
                      <li key={link.id}>
                        <a
                          href={
                            link.url.startsWith("http")
                              ? link.url
                              : `https://${link.url}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className={link.icon_class} />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* ── Nos Services ── */}
            <div className="col-lg-2 col-md-6 col-12">
              <div className="footer-widget">
                <h4 className="fw-title">Nos Services</h4>
                <ul className="footer-navigation">
                  {services.map((service) => (
                    <li key={service.id}>
                      <Link to={service.url} className="footer-link">
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* ── Nos Politiques ── */}
            <div className="col-lg-2 col-md-6 col-12">
              <div className="footer-widget">
                <h4 className="fw-title">Nos Politiques</h4>
                <ul className="footer-navigation">
                  {policies.map((item) => (
                    <li key={item.id}>
                      <a href={item.url} className="footer-link">
                        {item.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* ── Instagram ── */}
            <div className="col-lg-3 col-md-6 col-12 instagram-col">
              <div className="footer-widget">
                <h4 className="fw-title">Instagram</h4>
                <a
                  href="https://www.instagram.com/animaliaplus/?hl=fr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={instaImg}
                    alt="Instagram"
                    className="footer-img"
                  />
                </a>
              </div>
            </div>

          </div>
        </div>

        {/* Shapes */}
        {shapes.map((shape) => (
          <div
            key={shape.id}
            className={`footer-shape ${shape.position === "shape-two" ? "shape-two" : ""
              }`}
          >
            <img src={shape.image_url} alt="" />
          </div>
        ))}
      </div>

      {/* Copyright */}
      <div className="copyright-area">
        <div className="container">
          <p>{footer.copyright}</p>
        </div>
      </div>

      {/* ── Responsive Styles ── */}
      <style>{`
    .footer-navigation {
      list-style: none;
      padding-left: 0;
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 10px;
    }
.footer-mobile {
  display: none;
}
    .footer-link {
      text-decoration: none;
      color: inherit;
      transition: 0.3s ease;
        font-size: 0.8rem; /* adjust this value as needed */

    }

    .footer-link:hover {
      color: #ff41b4;
    }

    .footer-img {
      width: 260px;
height: auto;
      object-fit: contain;
      cursor: pointer;
    }
@media (max-width: 768px) {

    .f-logo img {
      width: 180px;
      height: auto;
            margin-left: 28px;

    }
      .footer-desktop {
    display: none;
  }

  .footer-mobile {
    display: block;
  }
  /* Push entire footer content 20px to the right */
  .footer-top-area .container,
  .copyright-area .container {
    padding-left: 30px !important;
  }

  .footer-top-area .row {
    flex-direction: column !important;
  }
.footer-text p {
  font-size: 14px;
  margin-left: 3px;
  margin-top: -10px;
}
  .footer-widget {
    margin-bottom: 20px;
  }

  .footer-img {
    margin-left: -20px;
  }

  /* Hide Instagram section on mobile */
  .instagram-col {
    display: none !important;
  }
}

  `}</style>
    </footer>

  );
}

export default Footer;
